import { render } from "./vatFiscalData.vue?vue&type=template&id=67736e5e&ts=true"
import script from "./vatFiscalData.vue?vue&type=script&lang=ts"
export * from "./vatFiscalData.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\equistasi\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__